import { providersFromAPIConstants } from '../constants'

const initialState = {}

export default (state = initialState, action = {}) => {
    const { slug } = action
    switch (action.type) {
        case providersFromAPIConstants.REQUEST:
            return {
                ...state,
                [slug]: {
                    ...(state[slug] || {}),
                    pending: true,
                },
            }
        case providersFromAPIConstants.SUCCESS:
            return {
                ...state,
                [slug]: {
                    response: action.response,
                    pending: false,
                },
            }
        case providersFromAPIConstants.FAILURE:
            return {
                ...state,
                [slug]: {
                    error: action.error,
                    pending: false,
                },
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/providersFromAPI.js